import { Link } from "react-router-dom";
import { clues } from "@/mocks/clueData";
import ClueCard from "@/components/feature/ClueCard";
import SectionHeading from "@/components/feature/SectionHeading";

export default function LatestClues() {
  const featured = clues[0];
  const rest = clues.slice(1, 4);

  return (
    <section className="mx-auto w-full px-4 py-16 md:px-8 md:py-20">
      <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <SectionHeading
          eyebrow="编辑精选"
          icon="ri-bookmark-3-line"
          title="最新网友投稿"
          desc="以下内容来自网友投稿，我们只做事实核对与隐私处理，把叙事顺序整理清楚后呈现给你。"
        />
        <Link
          to="/clues"
          className="inline-flex items-center gap-1 whitespace-nowrap self-start text-sm font-semibold text-primary-700 hover:text-primary-800 md:self-auto"
        >
          查看全部爆料
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-12">
        <article className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 lg:col-span-7">
          <div className="h-64 w-full overflow-hidden bg-background-200 md:h-80">
            <img
              src={featured.image}
              alt={featured.imageAlt}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <div className="p-6">
            <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-600">
              <span className="rounded-full bg-primary-100 px-2.5 py-0.5 font-medium text-primary-800">
                {featured.categoryName}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-fire-line text-primary-600"></i>
                编辑推荐
              </span>
              <span>{featured.date}</span>
            </div>
            <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
              <Link to={`/clues/${featured.slug}`} className="hover:text-primary-700">
                {featured.title}
              </Link>
            </h3>
            <p className="mt-3 line-clamp-3 text-sm leading-7 text-foreground-600">
              {featured.excerpt}
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-4 text-xs text-foreground-500">
              <span className="flex items-center gap-1">
                <i className="ri-user-line"></i>
                {featured.author}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-time-line"></i>
                {featured.readTime}
              </span>
            </div>
          </div>
        </article>

        <div className="flex flex-col gap-6 lg:col-span-5">
          {rest.map((clue) => (
            <ClueCard key={clue.id} clue={clue} variant="horizontal" />
          ))}
        </div>
      </div>
    </section>
  );
}